// extracted by mini-css-extract-plugin
export default {"performanceSelector":"performanceSelector_performanceSelector__odvnn","selected":"performanceSelector_selected__jba6S"};